export const WHAT_FILTER_UPDATE_EVENT = "filter_what";
export const WHERE_FILTER_UPDATE_EVENT = "filter_where";
export const WHERE_FILTER_HOTEL_NAME_SEARCH = "filter_where_hotel_name";
export const WHERE_FILTER_RECENT_SEARCH = "filter_where_recent";
export const WHERE_FILTER_DESTINATION_NO_MATCH = "filter_where_destination_no_match";
export const WHERE_FILTER_HOTEL_NO_MATCH = "filter_where_hotel_no_match";
export const WHEN_FILTER_UPDATE_EVENT = "filter_when";
export const WHO_FILTER_UPDATE_EVENT = "filter_who";
export const BUDGET_FILTER_UPDATE_EVENT = "filter_budget";
export const PROPERTY_CLASS_FILTER_UPDATE_EVENT = "sec_filter_class";
export const NIGHTS_FILTER_UPDATE_EVENT = "sec_filter_nights";
export const STOPS_FILTER_UPDATE_EVENT = "sec_filter_flight_stops";
export const DURATION_FILTER_UPDATE_EVENT = "sec_filter_duration";
export const FREE_CANCELLATION_FILTER_UPDATE_EVENT = "sec_filter_cancel";
export const BOARD_TYPE_FILTER_UPDATE_EVENT = "sec_filter_board_type";
export const AMENITIES_FILTER_UPDATE_EVENT = "sec_filter_amenities";
export const REFUNDABILITY_FILTER_UPDATE_EVENT = "sec_filter_refundability";
export const LUGGAGE_FILTER_UPDATE_EVENT = "sec_filter_luggage";
export const SEC_FILTER_OPEN = "sec_filter_open";
export const APPLY_PRICE_GRAPH_EVENT = "price_graph_apply";
export const PRICE_GRAPH_CHANGE_NIGHTS = "price_graph_change_nights";
export const PRICE_GRAPH_CHANGE_MONTH = "price_graph_change_month";
export const PRICE_GRAPH_SELECT_DATE = "price_graph_select_date";
export const DEAL_CLICK_EVENT = "offer_click";
export const LOAD_MORE_DEALS_EVENT = "offers_load_more";
export const LOCATION_DEAL_CLICK_EVENT = "offer_click_noncached";
export const LOAD_MORE_LOCATION_DEALS_EVENT = "offers_load_more_noncached";
export const LOAD_MORE_LOCATION_DEALS_FINISHED_EVENT = "offers_load_more_noncached_finished";
export const LOAD_LOCATION_DEALS_EVENT = "loadOffersNonCached";
export const LOAD_OFFERS_EVENT = "loadOffers";
export const LOAD_OFFERS_ONTHEFLY_EVENT = "loadOffersOnTheFly";
export const NO_OFFERS_EVENT = "noOffers";
export const LOAD_SEARCH_RESULTS_EVENT = "loadSearchResultsFinished";
export const LOAD_SEARCH_RESULTS_TO_DISPLAY_EVENT = "loadSearchResultsToDisplayFinished";
export const PAGINATION_CLICKED_EVENT = "pagginationClicked";
export const HOTEL_GALLERY_CLICKED_EVENT = "hotelGalleryClicked";
export const SORT_BY_EVENT = "sortBy";
export const FILTER_RESET_X_EVENT = "ResetX";
export const FILTER_RESET_BUTTON_EVENT = "ResetButton";
export const FILTER_RESET_ALL_FILTERS_EVENT = "resetAllFilters";
export const FILTER_OPEN = "filter_open";
export const FILTER_CLOSE = "filter_close";
export const MYFAVORITES_LOADED_EVENT = "myFavorites_loaded";
export const MYFAVORITES_SAVE_EVENT = "myFavorites_saveOffer";
export const MYFAVORITES_REMOVE_EVENT = "myFavorites_removeOffer";
export const ONBOARDING_LANDING_STEP = 'wizard_landing_step';
export const ONBOARDING_STEP_EVENT = "wizard_step_change";
export const ONBOARDING_STEP_LOADED_EVENT = "wizard_step_loaded";
export const ONBOARDING_SKIP_EMAIL_EVENT = "wizard_skip_email";
export const ONBOARDING_V2_SKIP_EMAIL_EVENT = "wizard_v2_skip_email";
export const ONBOARDING_SAVE_AND_GO_EVENT = "wizard_save_and_go_click";
export const ONBOARDING_TYPE_EMAIL_EVENT = "wizard_type_email";
export const ONBOARDING_SKIP_HOME_EVENT = "wizard_skip_onboarding";
export const ONBOARDING_START_WIZARD_V2_EVENT = "wizard_start_onboarding_v2";
export const ONBOARDING_PLUS_CLICKED = "wizard_plus_button_clicked";
export const ONBOARDING_ADD_IMG = "wizard_add_image";
export const ONBOARDING_ADD_FOOTER = "wizard_add_footer";
export const SEARCH_OUT_OF_CACHE_NIGHTS = "search_out_of_cache_boundaries_nights";
export const DISPLAY_PARAMETERS = "offer_display_parameters";
export const MOREIN_CITY_CLICK = "morein_city_click";
export const MOREIN_COUNTRY_CLICK = "morein_country_click";
export const REMOVE_CITY_CLICK = "remove_city_click";
export const GET_PAGE_FROM_URL = "get_page_from_url";
export const ROOM_NUM_INCREASE = "room_num_increase";
export const EDUCATIONAL_MESSAGES = "travelyo:hf.edu_msgs";
export const RELOADPOPUP_SHOWN = "reload_popup_shown";
export const CHOOSE_SPECIFIC_DATES_BLOCK = "choose_specific_dates_shown";
export const SEARCH_PERFORMED = "search_performed";
export const SA_SEARCH_PERFORMED = "sa_search_performed";
export const USER_PROFILE_SOFT_AUTHENTICATED = "user_profile_soft_authenticated";
export const ENTRY_POPUP_SHOWN = "entry_popup_shown";
export const ENTRY_POPUP_CLOSED = "entry_popup_closed";
export const ENTRY_FLOW_INIT = "entry_flow_init";
export const ENGINE_ORIGIN_OPENED = "engine_origin_opened";
export const ENGINE_ORIGIN_APPLIED = "engine_origin_applied";
export const LOOKING_FOR_ANOTHER_ORIGIN_CLICKED = "looking_for_another_origin_clicked";
export const AIRPORT_CONTINUE = "airport_continue";
export const AIRPORT_SAVE = "airport_save";
export const OPEN_LOGIN_BLOCK = "open_login_block";
export const CLOSE_LOGIN_BLOCK = "close_login_block";
export const MAYBELATER_LOGIN_BLOCK = "maybelater_login_block";
export const FB_LOGIN_CLICK = "fb_login_click";
export const GOOGLE_LOGIN_CLICK = "google_login_click";
export const LAST_SEARCH_CLICKED = "last_search_clicked";
export const LAST_SEARCH_WIZARD_SKIP = "last_search_wizard_skip";
export const ERROR_BOUNDARY = "error_boundary";
export const BIG_GROUP_CLICK = "big_group_click";
export const DOTD_LOADED = "dotd_loaded";
export const DOTD_CARD_CLICK = "dotd_card_click";
export const DOTD_POPUP_DISPLAYED = "dotd_popup_displayed";
export const DOTD_POPUP_CLOSE = "dotd_popup_close";
export const DOTD_SUBSCRIBE_CLICK = "dotd_subscribe_click";

// Customize button events
export const CUSTOMIZE_BUTTON_CLICKED = 'customize_button_clicked';
export const CUSTOMIZE_WHAT_CLICKED = 'customize_what_clicked';
export const CUSTOMIZE_WHAT_SAVED = 'customize_what_saved';
export const CUSTOMIZE_WHERE_CLICKED = 'customize_where_clicked';
export const CUSTOMIZE_WHERE_SAVED = 'customize_where_saved';
export const CUSTOMIZE_WHERE_NAME_NO_MATCH_FOUND = 'customize_where_name_no_match_found';
export const CUSTOMIZE_WHEN_CLICKED = 'customize_when_clicked';
export const CUSTOMIZE_WHEN_DATE_TYPE_CLICKED = 'customize_when_date_type_clicked';
export const CUSTOMIZE_WHEN_SAVED = 'customize_when_saved';
export const CUSTOMIZE_WHO_CLICKED = 'customize_who_clicked';
export const CUSTOMIZE_WHO_INCREASE_ROOM_CLICKED = 'customize_who_increase_room_clicked';
export const CUSTOMIZE_WHO_SAVED = 'customize_who_saved';
export const CUSTOMIZE_DEPARTURE_AIRPORT_CLICKED = 'customize_departure_airport_clicked';
export const CUSTOMIZE_DEPARTURE_AIRPORT_ANOTHER_CLICKED = 'customize_departure_airport_another_clicked';
export const CUSTOMIZE_DEPARTURE_AIRPORT_SAVED = 'customize_departure_airport_saved';
export const CUSTOMIZE_FILTERS_CLICKED = 'customize_filters_clicked';
export const CUSTOMIZE_FILTERS_SAVED = 'customize_filters_saved';
export const CUSTOMIZE_UPDATE_FEED_CLICKED = 'customize_update_feed_clicked';
export const CUSTOMIZE_START_WIZARD = 'customize_start_wizard';

export const RESULT_CARD_SWIPED = 'Results card image swiped';
export const RESULT_CARD_MESSAGE_DISPLAYED = 'Results card image message displayed';

export const GROUP_BOOKING_TUTORIAL_1 = 'Book with friends tutorial 1 displayed';
export const GROUP_BOOKING_TUTORIAL_2 = 'Book with friends tutorial 2 displayed';

export const WIZARD_AI_LOADED = 'wizard_assistant_loaded';
export const WIZARD_HINT_CLICKED = 'wizard_hint_clicked';
export const WIZARD_FEED_BUILDER_CLICKED = 'wizard_feed_builder_clicked';
export const WIZARD_GENERATE_FEED_CLICKED = 'wizard_generate_feed_clicked';
export const WIZARD_AI_RESPONSE_RECEIVED = 'wizard_assistant_response_received';
export const WIZARD_SECOND_VISIT_LOADED = 'wizard_second_visit_loaded';
export const WIZARD_SECOND_VISIT_ANSWERED = 'wizard_second_visit_answered';
export const WIZARD_UNSUPPORTED_SEARCH_DISPLAYED = 'Results page ai search out of range displayed';

export const WIZARD_FEEDBACK_DISPLAYED = 'Results page feedback popup displayed';
export const WIZARD_FEEDBACK_ANSWERED = 'Results page feedback popup answered';
export const WIZARD_FEEDBACK_START_OVER_DISPLAYED = 'Results page feedback start-over popup displayed';
export const WIZARD_FEEDBACK_START_OVER_CLOSED = 'Results page feedback start-over popup closed';

export const WIZARD_AIRPORT_REGIONS_LOADED = 'Wizard Airport regions loaded';
export const WIZARD_AIRPORT_REGIONS_ANSWERED = 'Wizard Airport regions answered';
export const WIZARD_AIRPORTS_LIST_LOADED = 'Wizard Airport list loaded';
export const WIZARD_AIRPORTS_LIST_ANSWERED = 'Wizard Airport list answered';
export const WIZARD_AIRPORT_COMPLETED = 'Wizard Airport completed';

export const WIZARD_HOTEL_PREF_LOADED = 'Wizard hotel pref loaded';
export const WIZARD_HOTEL_PREF_ANSWERED = 'Wizard hotel pref answered';
export const WIZARD_DYNAMIC_QUESTION_LOADED = 'wizard_dynamic_question_loaded';
export const WIZARD_DYNAMIC_QUESTION_ANSWERED = 'wizard_dynamic_question_answered';

export const PROPOSALS_LOADED = 'proposals_loaded';
export const PROPOSALS_COPY_LINK = 'proposals_copy_link';
export const PROPOSALS_DELETE_CLICKED = 'proposals_delete_clicked';
export const PROPOSALS_DELETE_CONFIRMED = 'proposals_delete_confirmed';
export const PROPOSALS_VIEW_CLICKED = 'proposals_view_clicked';
export const PROPOSAL_VIEW_LOADED = 'proposal_view_loaded';
